exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.card-default[data-v-47bf536f] {\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n}\n.list-group-item[data-v-47bf536f] {\n    cursor: pointer;\n}\n", ""]);

// exports
